import React from "react";
import {Doctor, InteractionHistory} from "../../dashboard";
import agent from "../../../agent";
import {Button, Dropdown, Form, Grid, Header, Loader, Segment, TextArea} from "semantic-ui-react";
import styles from "../index.module.css";
import {DoctorTitleCase, getDoctorTitle, getPatientTitle, PatientTitleCase} from "../../../utils/common";
import {DoctorPaginationResponse} from "../../workTableDoctors/DoctorsList";
import {hasRole, UserRole} from "../../../helpers/UserRole";
import {Utils} from "../../../helpers/Utils";
import {InteractionHistoryStatusOptions} from "../../../consts/EventConsts";
import { textLabels } from "../../../consts/textLabels";

interface Props {
    patientId: string;
}

interface State {
    loading: boolean,
    interactionHistoryList: InteractionHistory[],
    editedElementIndex: number | undefined,
    editedComment: string | undefined,
    editedStatus: string | undefined,
    doctors: Doctor[]
}


class InteractionHistoryTab extends React.PureComponent<Props, State> {
    state: State = {
        loading: true,
        interactionHistoryList: [],
        editedElementIndex: undefined,
        editedComment: undefined,
        editedStatus: undefined,
        doctors: []
    };
    async componentDidMount() {
        await this.onMount();
    };

    onMount = async (): Promise<void> => {
        const list: InteractionHistory[] = await agent.PatientProvider.getInteractionHistory(this.props.patientId);
        const response: DoctorPaginationResponse = await agent.DoctorProvider.getList();
        this.setState({
            interactionHistoryList: list,
            loading: false,
            doctors: response.docs
        });
    };

    getDoctorFullName = (doctorId: string): string => {
        if (doctorId==='000000000000000000000001') {
            return 'Администратор'
        } else {
            const doctor: Doctor | undefined = this.state.doctors.find((el: Doctor) => el._id === doctorId);
            return doctor ? Utils.getFullName(doctor.surname, doctor.name, doctor.middlename) : '';
        }
    };

    render() {
        return (
            this.state.loading ?
                <Loader active/>
                :
                <div className={styles.containerInteractionHistory}>
                    <Grid stackable stretched>

                        <Grid.Column floated={"right"} width={2}>
                            {
                                <Button
                                    size={'small'}
                                    color={'green'}
                                    type={'submit'}
                                    content={textLabels.createButton}
                                    disabled={hasRole(UserRole.OBSERVER)}
                                    onClick={async () => {
                                        this.setState({loading: true});
                                        const list: InteractionHistory[] = await agent.PatientProvider
                                            .createInteractionHistory(this.props.patientId);
                                        this.setState({
                                            interactionHistoryList: list,
                                            loading: false,
                                            editedElementIndex: undefined,
                                            editedComment: undefined,
                                            editedStatus: undefined
                                        });
                                    }}
                                />
                            }
                        </Grid.Column>
                    </Grid>
                    {this.state.interactionHistoryList.map((el, index) => {
                        if (el.status === undefined) {
                            el.status = ''
                        }
                        return <Segment color={el.manual ? "purple" : undefined}>
                            <Header>
                                Создано: {(el.manual && el.userCreate) ? this.getDoctorFullName(el.userCreate)+', ' : ''}{new Date(el.date).toLocaleString()}
                                <br/>
                                {(el.dateUpdate && el.userUpdate && el.dateUpdate!==el.date) ?
                                `Отредактировано: ${el.userUpdate ? this.getDoctorFullName(el.userUpdate) : ''}, ${new Date(el.dateUpdate).toLocaleString()}` : ''}
                            </Header>
                            {this.state.editedElementIndex !== index ?
                                <Form>
                                    <TextArea
                                        value={el.comment}
                                        disabled={hasRole(UserRole.OBSERVER)}
                                        onFocus={() => {
                                            if (this.state.editedElementIndex === undefined) {
                                                this.setState({
                                                    editedElementIndex: index,
                                                    editedComment: el.comment,
                                                    editedStatus: el.status
                                                });
                                            }
                                        }}
                                    />
                                    {
                                        el.manual===false &&
                                        <Form.Field width={3} style={{marginTop: '10px'}}>
                                            <Dropdown
                                                placeholder="Выберите статус"
                                                disabled={hasRole(UserRole.OBSERVER)}
                                                fluid
                                                clearable
                                                selection
                                                options={InteractionHistoryStatusOptions}
                                                value={el.status}
                                                onFocus={() => {
                                                    if (this.state.editedElementIndex === undefined) {
                                                        this.setState({
                                                            editedElementIndex: index,
                                                            editedComment: el.comment,
                                                            editedStatus: el.status
                                                        });
                                                    }
                                                }}
                                            />
                                        </Form.Field>
                                    }
                                </Form>
                                :
                                <Form>
                                    <TextArea
                                        value={this.state.editedComment}
                                        disabled={hasRole(UserRole.OBSERVER)}
                                        onChange={(e) => {
                                            this.setState({editedComment: e.currentTarget.value});
                                        }}
                                        style={{marginBottom: '10px'}}
                                    />
                                    {
                                        el.manual===false &&
                                        <Form.Field width={3} style={{marginBottom: '10px'}}>
                                            <Dropdown
                                                placeholder="Выберите статус"
                                                disabled={hasRole(UserRole.OBSERVER)}
                                                fluid
                                                clearable
                                                selection
                                                options={InteractionHistoryStatusOptions}
                                                value={this.state.editedStatus}
                                                onChange={(e, {value}) => {this.setState({
                                                    editedStatus: value as string
                                                })}}
                                            />
                                        </Form.Field>
                                    }
                                    <Button type={"submit"} primary onClick={() => {
                                        agent.PatientProvider
                                            .editInteractionHistory(el.id, this.state.editedComment!, this.state.editedStatus!)
                                            .finally(() => {
                                                    this.setState({
                                                        editedComment: undefined,
                                                        editedStatus: undefined,
                                                        editedElementIndex: undefined
                                                    });
                                                    this.onMount();
                                                }
                                            );
                                    }}>{textLabels.saveButton}</Button>
                                    <Button onClick={() => {
                                        this.setState({
                                            editedComment: undefined,
                                            editedStatus: undefined,
                                            editedElementIndex: undefined
                                        })
                                    }}>Отменить</Button>
                                </Form>
                            }
                        </Segment>
                    })}
                </div>
        )
    }
}

export default InteractionHistoryTab;
